import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import { Panel } from '@/components/Panel';
import { BackLink, type BackLinkProps } from './BackLink';

/**
 * En-tête d'une fiche, sous son lien retour : pastille facultative, titre, sous-titre, actions à droite, puis les
 * valeurs (<Value> de DashboardParts). label nomme la région (lecteurs d'écran, tests).
 */
export function DetailHeader({
  back,
  label,
  avatar,
  title,
  subtitle,
  actions,
  columns = 5,
  children,
}: {
  back: BackLinkProps;
  label: string;
  avatar?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  actions: ReactNode;
  /** Colonnes des valeurs sur grand écran */
  columns?: 2 | 5;
  /** Les <Value> */
  children: ReactNode;
}) {
  const heading = (
    <div>
      <h2 className="text-xl font-bold text-slate-900">{title}</h2>
      {subtitle}
    </div>
  );

  return (
    <div>
      <BackLink {...back} />
      <Panel as="section" className="p-6" aria-label={label}>
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 justify-between">
          {avatar ? (
            <div className="flex items-center gap-4">
              {avatar}
              {heading}
            </div>
          ) : (
            heading
          )}
          <div className="flex flex-wrap gap-2">{actions}</div>
        </div>

        <dl className={clsx('mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4', columns === 5 && 'xl:grid-cols-5')}>
          {children}
        </dl>
      </Panel>
    </div>
  );
}
